"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMapChildren = exports.mapChildren = exports.validateNode = void 0;
const react_1 = __importStar(require("react"));
const ReactIs = __importStar(require("react-is"));
// What the hell does this do!?
const validateNode = (node, el) => (0, react_1.isValidElement)(node) || !node ? node : el ? el : `${node}`;
exports.validateNode = validateNode;
/** Maps over the first level of children. Will ignore fragments until a first non-fragment child is found */
const mapChildren = (children, fn) => {
    const mapped = react_1.default.Children.map(children, (child) => {
        var _a;
        if (ReactIs.isFragment(child)) {
            if (child.props.children) {
                return (0, exports.mapChildren)(child.props.children, fn);
            }
        }
        else {
            return (_a = fn(child)) !== null && _a !== void 0 ? _a : undefined;
        }
    });
    if (Array.isArray(mapped)) {
        if (mapped.length === 0)
            return undefined;
        if (mapped.length === 1)
            return mapped[0];
    }
    return mapped;
};
exports.mapChildren = mapChildren;
/** Maps over all levels of children */
const deepMapChildren = (children, fn) => {
    const mapped = react_1.default.Children.map(children, (child) => {
        var _a;
        if ((0, react_1.isValidElement)(child) && child.props.children) {
            child = (0, react_1.cloneElement)(child, {
                children: (0, exports.deepMapChildren)(child.props.children, fn),
            });
        }
        return (_a = fn(child)) !== null && _a !== void 0 ? _a : undefined;
    });
    if (Array.isArray(mapped)) {
        if (mapped.length === 0)
            return undefined;
        if (mapped.length === 1)
            return mapped[0];
    }
    return mapped;
};
exports.deepMapChildren = deepMapChildren;
//# sourceMappingURL=helpers.js.map